import { InteropFilterState } from '../interop-service/interop-interface.service';
import { InteropresultState} from '../interop-service/interop-interface.results';
import { Injectable } from '@angular/core';
import { BehaviorSubject ,  Subject ,  Observable } from 'rxjs';


@Injectable()
export class InteropDataService {
        data:Array<{}>;
        private messageSource = new BehaviorSubject<string>("default message");
        currentMessage = this.messageSource.asObservable();
        private filterSubject = new Subject<InteropFilterState>();
        FilterState = this.filterSubject.asObservable();
        private removeSubject = new Subject<InteropFilterState>();
        removeState = this.removeSubject.asObservable();
        

        constructor() {
             this.data=[];
        }

        addFilter(value:any,filtername:string) {
              value["filtername"]=filtername;
              this.filterSubject.next(<InteropFilterState>value);
            //   this.data.push(value);
            }

        addToData(value:any,filtername:string){
            value["filtername"]=filtername;
            this.data.push(value);
        }

        removeFilter(value:any) {
              this.removeSubject.next(<InteropFilterState>value); 
            }  


        changeMessage(message: string) {
              this.messageSource.next(message);
              //this.data=[{}];
        }
}